
import { Options, Vue } from 'vue-class-component'
import CardSteps from '@/components/CardSteps.vue'

@Options({
  components: { CardSteps }
})
export default class CardKeyword extends Vue {
}
